<div class="container" *ngIf="!isLoading">
    <div class="header">
        <div class="button-container">
            <button class="text-button" (click)="close()">
                {{ 'matrix.dialog.cancel.button' | translate }}
            </button>
            <app-button
                [disable]="isSaveButtonDisabled()"
                text="matrix.dialog.save.button"
                customFontFamily="NotoSans-SemiBold"
                size="small"
                customFontSize="14px"
                (onClick)="save()"></app-button>
        </div>
    </div>
    <div class="main">
        <div class="main-header">
            <div class="create-header">
                <div class="add-channel-container">
                    <div class="add-button-container">
                        <div
                            class="add-button"
                            [class.disable]="MAX_MATRIX_CHANNEL_NUM - matrixChannelList.length <= 0"
                            (click)="createMatrixChannel()">
                            <mat-icon svgIcon="plus"></mat-icon>
                        </div>
                        <div class="button-text">
                            <div class="button-name">
                                {{ 'matrix.dialog.add-channel.button.name' | translate }}
                            </div>
                            <div class="button-data-num">
                                {{
                                    'matrix.dialog.add-channel.description'
                                        | translate
                                            : {
                                                  num: matrixChannelList.length,
                                              }
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add-condition-container">
                    <div class="add-button-container">
                        <div class="add-button blue-button" (click)="createCondition()">
                            <mat-icon svgIcon="plus"></mat-icon>
                        </div>
                        <div class="button-text">
                            <div class="button-name">
                                {{ 'matrix.dialog.add-condition.button.name' | translate }}
                            </div>
                            <div class="button-data-num">
                                {{
                                    'matrix.dialog.add-condition.description'
                                        | translate
                                            : {
                                                  num: conditionList.length,
                                              }
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="condition-navigator">
                        <div class="condition-status">
                            {{
                                'matrix.dialog.pagenation.text'
                                    | translate
                                        : {
                                              startNum: this.conditionList.length ? getPageStart() + 1 : 0,
                                              endNum: this.currentPage * ONE_PAGE_DATA_NUM - getEmtpyArray().length,
                                              totalNum: this.conditionList.length,
                                          }
                            }}
                        </div>
                        <div class="arrow-container">
                            <mat-icon
                                class="icon arrow-icon"
                                svgIcon="arrow-circle"
                                (click)="goPrevPage()"
                                [class.disabled]="isPrevButtonDisabled()"></mat-icon>
                            <mat-icon
                                class="icon arrow-icon right-arrow"
                                svgIcon="arrow-circle"
                                (click)="goNextPage()"
                                [class.disabled]="isNextButtonDisabled()"></mat-icon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sub-header">
                <div class="channel-container-header">
                    <div class="input-container">
                        <div class="input-title">
                            {{ 'matrix.dialog.search-channel.title' | translate }}
                        </div>
                    </div>
                </div>
                <div class="condition-container-header">
                    <div class="condition-item-list">
                        <app-condition-item
                            *ngFor="let condition of getPageConditions()"
                            [condition]="condition"
                            [vessel]="data.vessel"
                            (onDeleteCondition)="deleteCondition($event)"
                            (onClearAllSetting)="clearAllSetting($event)"
                            (onSetToAlarm)="conditionSetToAlarm($event)"
                            (onSelectCondition)="selectCondition($event)"
                            (onSelectComponent)="selectComponent($event)">
                        </app-condition-item>
                        <app-condition-item *ngFor="let condition of getEmtpyArray()" [condition]="condition">
                        </app-condition-item>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-editor-matrix" #contentContainer>
            <div class="channel-row" *ngFor="let matrixChannel of matrixChannelList">
                <div class="channel-item" #channelRows>
                    <div class="channel-information">
                        <span class="channel-number">{{ matrixChannel?.channel?.opsData.tag }}</span>
                        <span class="channel-name">{{ matrixChannel?.channel?.opsData.name }}</span>
                    </div>
                    <mat-icon
                        svgIcon="more-options"
                        class="icon options-icon"
                        [class.selected]="
                            matrixChannel?.index === selectedMatrixChannel?.index && isOpenMatrixChannelOption
                        "
                        (click)="openOption(matrixChannel); $event.stopPropagation()"></mat-icon>
                    <div
                        #channelMoreOptions
                        class="more-options-container"
                        [style.top]="optionsTop"
                        [style.left]="optionsLeft"
                        [class.show]="
                            matrixChannel?.index === selectedMatrixChannel?.index && isOpenMatrixChannelOption
                        ">
                        <div class="button" (click)="deleteMatrixChannel(matrixChannel)">
                            {{ 'matrix.dialog.channel.option.delete' | translate }}
                        </div>
                        <div class="button" (click)="clearSetting(matrixChannel)">
                            {{ 'matrix.dialog.channel.option.clear' | translate }}
                        </div>
                    </div>
                </div>
                <div
                    class="condition-item-logic"
                    *ngFor="let logic of matrixChannel?.logicList?.slice(getPageStart(), getPageEnd()); index as i">
                    <app-condition-logic-input
                        [logic]="logic"
                        (onChangeLogic)="changeConditionLogic($event, matrixChannel)"
                        (onFocus)="selectConditionLogic($event)"
                        (onBlur)="unSelectedConditionLogic()">
                    </app-condition-logic-input>
                </div>
                <div class="condition-item-logic" *ngFor="let logic of getEmtpyArray()">
                    <app-condition-logic-input [logic]="logic"> </app-condition-logic-input>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="event-name">
            <span class="selected-channel">{{
                'matrix.dialog.select-channel'
                    | translate
                        : {
                              name:
                                  (selectedMatrixChannel?.channel?.opsData?.tag
                                      ? selectedMatrixChannel?.channel?.opsData?.tag
                                      : '') +
                                  ' ' +
                                  (selectedMatrixChannel?.channel?.opsData?.name
                                      ? selectedMatrixChannel?.channel?.opsData?.name
                                      : ''),
                          }
            }}</span>
            <span class="selected-condition">{{
                'matrix.dialog.select-condition'
                    | translate
                        : {
                              name: selectedCondition?.name ? selectedCondition?.name : '',
                          }
            }}</span>
        </div>
        <div class="undo-container" *ngIf="undoMessage">
            <div class="undo-message">
                {{ undoMessage }}
            </div>
            <div class="undo-button" (click)="applyUndoEvent()">
                {{ 'matrix.dialog.undo.button.text' | translate }}
                <mat-icon class="icon" svgIcon="undo"></mat-icon>
            </div>
            <div class="undo-button" (click)="cancelUndoEvent()">
                {{ 'matrix.dialog.close.button.text' | translate }}
                <mat-icon class="icon close-icon" svgIcon="close"></mat-icon>
            </div>
        </div>
    </div>
</div>

<app-loading-spinner
    *ngIf="isLoading"
    class="spinner-component"
    [custom]="true"
    size="80"
    strokeWidth="3"></app-loading-spinner>

<app-confirmation-window
    #deleteDialog
    [mainLabel]="deleteMainMessage"
    [subLabel]="deleteSubMessage"
    [goBackLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.confirm'"
    [inverseColors]="true"
    [smallDialog]="true"></app-confirmation-window>
